import { useState } from 'react';
import { Box, TypographyVariant } from '@mui/material';
import { Button, Typography } from '@chr/eds-react';
import { useTranslation } from '@chr/online-shared-ui-localizations';

export interface ShowMoreTextProps {
  text: string;
  maxCharacters?: number;
  variant?: TypographyVariant;
}

export const ShowMoreText = (props: ShowMoreTextProps) => {
  const translate = useTranslation();
  const maxCharacters = props.maxCharacters ?? 160;
  const variant: TypographyVariant = props.variant ?? 'body2';
  const [isExpanded, setIsExpanded] = useState(false);

  if (props.text.length < maxCharacters) {
    return (
      <Typography variant={variant}>{props.text}</Typography>
    );
  }

  const truncatedText = props.text.slice(0, maxCharacters).trimEnd();
  return (
    <>
      <Typography variant={variant}>
        {isExpanded ? props.text : truncatedText}
        {!isExpanded && '...'}
      </Typography>
      <Box sx={{ minWidth: 150 }}>
        <Button
          startIcon={isExpanded ? 'expand_less' : 'expand_more'}
          onClick={() => setIsExpanded(!isExpanded)}
          variant={"tertiary"}
          buttonText={translate(isExpanded ? 'View Less' : 'Read More')}
        />
      </Box>
    </>
  );
};
